export default __webpack_public_path__ + "static/media/3d_gismo.4bc3edc0.svg";